export const styles = {
    container: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '10px',
        paddingBottom: '10px',
    },
    titleWrapper: {
        flex: 1
    },
    title: {
        fontSize: '28px',
        fontWeight: 'bold',
        color: '#333',
        marginBottom: '5px'
    },
    titleInput: {
        width: '100%',
        fontSize: '28px',
        fontWeight: 'bold',
        padding: '10px 0',
        border: 'none',
        borderBottom: '2px solid #eaeaea',
        outline: 'none',
        marginBottom: '20px',
        transition: 'border-color 0.3s',
        backgroundColor: 'transparent'
    },
    actions: {
        display: 'flex',
        gap: '10px'
    },
    button: {
        padding: '10px 16px',
        borderRadius: '4px',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: 'none',
        outline: 'none'
    },
    primaryButton: {
        backgroundColor: 'black',
        color: 'white',
    },
    secondaryButton: {
        backgroundColor: 'white',
        color: '#333',
        border: '1px solid #d1d5db'
    },
    switchButton: {
        backgroundColor: '#e5e7eb',//preview ? '#f3f4f6' : '#e5e7eb',
        color: '#374151'
    },
    toolbarButton: {
        padding: '6px 10px',
        backgroundColor: 'transparent',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        color: '#4b5563',
        fontSize: '14px',
        margin: '0 2px',
        transition: 'background-color 0.2s'
    },
    activeToolbarButton: {
        backgroundColor: '#e5e7eb'
    },
    toolbar: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '5px',
        padding: '10px',
        backgroundColor: '#f9fafb',
        borderRadius: '4px 4px 0 0',
        borderBottom: '1px solid #e5e7eb',
        marginBottom: '0'
    },
    toolbarGroup: {
        display: 'flex',
        marginRight: '15px'
    },
    editorContainer: {
        border: '1px solid #e5e7eb',
        borderRadius: '0 0 4px 4px',
        overflow: 'hidden',
        marginBottom: '20px'
    },
    editor: {
        minHeight: '400px',
        padding: '20px',
        fontSize: '16px',
        lineHeight: '1.8',
        outline: 'none',
        overflowY: 'auto'
    },
    stats: {
        display: 'flex',
        color: '#6b7280',
        fontSize: '14px',
        flexDirection: 'column',
    },
    footer: {
        display: 'flex',
        color: '#6b7280',
        fontSize: '14px',
        marginTop: '20px',
        paddingTop: '10px',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    preview: {
        padding: '20px 0',
        lineHeight: '1.8',
        fontSize: '16px'
    },
    previewTitle: {
        fontSize: '32px',
        fontWeight: 'bold',
        marginBottom: '20px',
        color: '#111',
        textAlign: 'center'
    },
    previewContent: {
        'h1': {
            fontSize: '28px',
            fontWeight: 'bold',
            marginBottom: '16px',
            marginTop: '32px'
        },
        'h2': {
            fontSize: '24px',
            fontWeight: 'bold',
            marginBottom: '14px',
            marginTop: '28px'
        },
        'h3': {
            fontSize: '20px',
            fontWeight: 'bold',
            marginBottom: '12px',
            marginTop: '24px'
        },
        'p': { marginBottom: '16px' },
        'ul, ol': { marginBottom: '16px', paddingLeft: '20px' },
        'li': { marginBottom: '8px' },
        'blockquote': {
            borderLeft: '4px solid #e5e7eb',
            paddingLeft: '16px',
            fontStyle: 'italic',
            color: '#4b5563',
            margin: '16px 0'
        },
        'img': {
            maxWidth: '100%',
            height: 'auto',
            borderRadius: '4px',
            margin: '16px 0'
        },
        'a': {
            color: '#3b82f6',
            textDecoration: 'none'
        }
    }
};